export const getCookie = (name, cookie) => {
    var _a;
    const prefix = `${name}=`;
    const cookieValue = (_a = cookie
        .split('; ')
        .find((row) => row.startsWith(prefix))) === null || _a === void 0 ? void 0 : _a.split('=')[1];
    return cookieValue ? decodeURI(cookieValue) : null;
};
